import React from 'react';
import { parseMetaIdsFromRef } from '../services/FacebookAdsService';

const MetaAdInfo = ({ lead }) => {
  // If no ref data, don't render anything
  if (!lead?.ref) return null;
  
  // Check if this is a Facebook lead
  const { campaignId, adSetId, adId } = parseMetaIdsFromRef(lead.ref);
  if (!campaignId && !adSetId && !adId) return null;
  
  return (
    <div className="space-y-2 text-xs">
      <div className="text-gray-600 italic">
        <span className="font-medium">Facebook Ad IDs:</span>
        <div>
          {campaignId && <div>Campaign: {campaignId}</div>}
          {adSetId && <div>Ad Set: {adSetId}</div>}
          {adId && <div>Ad: {adId}</div>}
        </div>
      </div>
    </div>
  );
};

export default MetaAdInfo; 